export const isCustomCourseEmailConfigured = (settings) => {
    return settings && 
           settings.courseBodyText && 
           settings.courseBodyText.trim() !== "" &&
           settings.courseBodyText.trim() !== " ";
};

export const isCustomReportedSimEmailConfigured = (settings) => {
    return settings && 
           settings.reportedSimBodyText && 
           settings.reportedSimBodyText.trim() !== "" &&
           settings.reportedSimBodyText.trim() !== " ";
};